// extracted by mini-css-extract-plugin
export var root = "x_sY";
export var wrapper = "x_sZ";
export var image = "x_s0 d_s d_v d_S";
export var crop = "x_s1";
export var round = "x_s2";
export var fixedHeight = "x_s3";